import type {DashboardOverviewFilters} from "../types";

/**
 * Stable TanStack Query key for overview — sorted property ids so cache hits
 * are not missed when the same set is passed in a different order.
 */
export function getDashboardOverviewQueryKey(filters: DashboardOverviewFilters) {
  const scope =
    filters.context_property_ids.length === 0
      ? ""
      : [...filters.context_property_ids].sort((a, b) => a - b).join(",");
  return ["dashboard-overview", filters.period, scope] as const;
}
